import React from 'react';

import * as Styled from './priority-fire.styles';

const LAYERS: Styled.FlameLayer[] = ['back', 'medium', 'front'];

const PriorityFire: React.FC = () => (
  <Styled.Fire aria-hidden="true">
    {LAYERS.map((layer) => (
      <Styled.Flame key={layer} $layer={layer}>
        <Styled.Drop $layer={layer} />
      </Styled.Flame>
    ))}
  </Styled.Fire>
);

export default React.memo(PriorityFire);
